<template>
	<AppBottomSheet :active="active" :forceWidth="bottomSheetWidth" @toggling-popup="open => $emit('toggling-popup', open)" >
		<div v-if="active">
			<ModalHeader
				:title="getString('select_country')"
			/>
			<div class="row centered mb-10">
				<p>{{ getString('europe') }}</p>
			</div>
			<div class="row centered countries-container mb-20">
				<AppButton
					v-for="(country, index) in selectableEuCountries"
					:key="index"
					:text="country"
					class="country-button"
					outline
					@click="$emit('selected-country', country)"
				/>
			</div>
			<div class="row centered mb-10">
				<p>{{ getString('rest_of_world') }}</p>
			</div>
			<div class="row centered countries-container mb-20">
				<AppButton
					v-for="(country, index) in selectableNonEuCountries"
					:key="index"
					:text="country"
					class="country-button"
					outline
					@click="$emit('selected-country', country)"
				/>
				<AppButton
					:text="getString('other_country')"
					class="country-button big"
					outline
					@click="$emit('selected-country', 'OO')"
				/>
			</div>
		</div>
	</AppBottomSheet>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppList from "@/shared/components/AppList.vue";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useCustomersStore, useUserStore} from "@/console-new/stores";
import AppButton from "@/shared/components/AppButton.vue";
import euCountriesFile from "@/shared/assets/json/euCountrycodes.json";
import nonEuCountriesFile from "@/shared/assets/json/nonEuCountrycodes.json";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		return {getString: languageStore.getString, euCountriesCodes: euCountriesFile, nonEuCountriesCodes: nonEuCountriesFile, showNotification: notificationStore.showNotification, userStore, customersStore}
	},
	name: "CompanyCountriesBottomsheet",
	components: {AppButton, AppGoogleMapsInput, ModalHeader, AppLoader, AppDropdown, AppList, AppBottomSheet},
	mixins: [WindowWidth],
	emits: ['toggling-popup', 'selected-country'],
	props: {
		active: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			dismissedSameVatFiscal: false,
			companyWithoutVat: false,
		}
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		selectableEuCountries() {
			return Object.keys(this.euCountriesCodes);
		},
		selectableNonEuCountries() {
			return Object.keys(this.nonEuCountriesCodes);
		},
	},
	methods: {

	}
}
</script>

<style scoped lang="scss">
.countries-container {
	gap: 10px;

	.country-button {
		@include noSelect;
		width: 60px;
		min-width: 60px;
		padding: 10px 0;
		&.outline {
			border: none;
			background-color: var(--color-alpha-2);
			:deep(.btn-text p) {
				color: var(--color-txt);
			}
		}

		&.big {
			width: unset;
			padding: 10px 10px;
		}
	}
}
</style>